import dayjs from "dayjs";
import { CurrencyCode } from "@acto/taskpane/core/utils/currencyCode";
import { formatCurrencyValue } from "@acto/taskpane/core/utils/currencyPattern";

export const formatCurrency = (value: number, locale: string, currency: CurrencyCode) =>
  formatCurrencyValue(value, locale, currency, { maximumFractionDigits: 0 });

export const formatChange = (value?: number | null) => {
  if (value === undefined || value === null) return undefined;
  const rounded = Math.round(value);
  const signed = rounded >= 0 ? `+${rounded}` : `${rounded}`;
  return `${signed}%`;
};

export const formatDate = (date: Date | string) => dayjs(date).format("DD.MM.YYYY");

export const formatShortDate = (date: Date | string) => dayjs(date).format("DD.MM.YY");
